export default __webpack_public_path__ + "static/media/nexters.fd5415c1.svg";